import React, { Component, ErrorInfo, ReactNode } from 'react';
import { BodyErrorAgent } from './components';
interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: string;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    sendlog(error);
    return { hasError: true, error: error.message };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return <BodyErrorAgent />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

function sendlog(error: Error) {
  /** Função para começarmos a trackear o log dos erros*/

  return console.log(error.stack);
}
